import React from 'react'
import ActionButton from 'components/ActionButton'
import { MultiLangJobDto } from 'api/multilangJob'
import { useRedirect } from 'ra-core'

const OpenMultiLangJob = ({ multiLangJob }: { multiLangJob?: MultiLangJobDto }) => {
  const redirect = useRedirect()
  const canOpen = multiLangJob !== undefined && multiLangJob.singleLangJobs.length > 1

  return <ActionButton disabled={!canOpen} onClick={() => redirect(`/multilang-jobs/${multiLangJob?.id}/show`)} >
    All Languages
  </ActionButton>
}

export default OpenMultiLangJob
